<template>
  <div v-if="row.reference" class="p-2">
    <h5 class="mb-3">Paiement reparation {{ row.reference }}</h5>
    <div class="row">
      <div class="col-md-6">
        <p><strong>Reparation :</strong> {{ row.repair_reference }}</p>
        <p v-if="row.repair">
          <strong>Client :</strong>
          {{
            row.repair.customer
              ? row.repair.customer.fullName
              : row.payment && row.payment.customer
              ? row.payment.customer.fullName
              : "—"
          }}
        </p>
        <p><strong>Date :</strong> {{ row.date }}</p>
        <p><strong>Montant :</strong> {{ formatMoney(row.amount) }}</p>
      </div>
      <div class="col-md-6" v-if="row.payment">
        <p><strong>Mode :</strong> {{ row.payment.paymentMethod }}</p>
        <p><strong>Ref. paiement :</strong> {{ row.payment.reference }}</p>
        <p v-if="row.payment.checkNumber">
          <strong>N chèque :</strong> {{ row.payment.checkNumber }}
        </p>
        <p v-if="row.payment.bankTransferNumber">
          <strong>Virement :</strong> {{ row.payment.bankTransferNumber }}
        </p>
      </div>
    </div>
    <p v-if="row.remark"><strong>Remarque :</strong> {{ row.remark }}</p>
    <div class="mt-3">
      <button
        class="btn btn-secondary me-2"
        @click="$router.push({ name: 'payments-repairs-index' })"
      >
        Retour
      </button>
      <button
        class="btn btn-primary"
        @click="
          $router.push({
            name: 'payments-repairs-edit',
            params: { reference: row.reference },
          })
        "
      >
        Modifier
      </button>
    </div>
  </div>
  <div v-else class="p-3 text-muted">Chargement</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("paymentRepair", { row: "getCurrent" }),
  },
  mounted() {
    const ref = this.$route.params.reference;
    if (ref) {
      this.$store.dispatch("paymentRepair/show", ref);
    }
  },
  methods: {
    formatMoney(v) {
      if (v == null) return "—";
      return parseFloat(v).toFixed(2) + " DH";
    },
  },
};
</script>
